"use strict";
const BaseAnalytics = require("../base/BaseAnalytics");

const { 
    PAGE_LOAD,
    PRODUCT_REVIEW_COMPLETE,
} = require("../models/Review");

class ReviewAnalytics extends BaseAnalytics {
    /**
     * This constructor sets the @property { string } this.file to be able to track which module may be throwing an error.
     *
     * @memberof ReviewAnalytics
     */
    constructor() {
        const DOM_PAGE_DATA = ["js-a-page-customer", "js-a-page-cart", "js-a-page-store", "js-a-page-data", "js-a-page-instance"];
        super("ReviewAnalytics", DOM_PAGE_DATA, PAGE_LOAD);
    }

    /**
     * Initializing the class with collect(), engages all analytics listeners
     *
     * @memberof ReviewAnalytics
     */
    collect() {
        this.prepareDOMElements();
        this.getPageData();
        this.baseEvents();
        this.baseInterceptedEvents();
        this.baseDelayedEvents();
        // this.pageEvents();
        // this.pageInterceptedEvents();
        this.pageDelayedEvents();
    }

    pageEvents() {
    }

    pageInterceptedEvents() {
    }

    pageDelayedEvents() {
        this.addEventWatcher("submit", document.getElementsByClassName("js-a-product-review-page"), ".pr-war", target => this.productReviewComplete(target));
    }

    /**
     * Prepare review start event
     *
     * @memberof ReviewAnalytics
     */
    productReviewComplete() {
        const reviewParent = document.getElementsByClassName("js-a-product-review-page")[0];

        if (reviewParent) {
            let domData = {
                products: [
                    {
                        id: reviewParent.dataset.id
                    }
                ]
            };

            this.prepareSingleEvent(PRODUCT_REVIEW_COMPLETE, domData);
        }
    }
}

module.exports = ReviewAnalytics;
